export function parseHtml(data) {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    return domToJson(doc.documentElement);
  } catch (error) {
    console.error("HTML parsing error:", error);
    throw error;
  }
}

function domToJson(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    const trimmed = node.nodeValue.trim();
    return trimmed ? trimmed : null;
  }
  const obj = {
    tag: node.tagName ? node.tagName.toLowerCase() : "text",
    attributes: {},
    children: [],
  };

  if (node.attributes) {
    for (let attr of node.attributes) {
      obj.attributes[attr.name] = attr.value;
    }
  }

  for (let child of node.childNodes) {
    const childJson = domToJson(child);
    if (childJson !== null) {
      obj.children.push(childJson);
    }
  }
  return obj;
}
